module.exports = __webpack_public_path__ + "static/media/gloria77.98c35c40.png";